<script setup lang="ts">
import { computed, unref } from "vue";
import { RouterLink } from "vue-router";
import { useStore } from "vuex";
import ErrorPlane from "@/components/shared/ErrorPlane.vue";
import ArrowBack from "@/components/shared/icons/ArrowBack.vue";
import type { Props } from "./types.ts";

defineOptions({
  name: "RegistrationErrors",
});

const props = withDefaults(defineProps<Props>(), {
  title: "Registration Errors",
});

const store = useStore();

const isLoggedIn = computed<boolean>(() => store.getters.isLoggedIn);

const hasOrder = computed<boolean>(() => Boolean(unref(props.associatedOrder)));

const returnText = computed<string>(() => {
  if (hasOrder.value) {
    return "Please return to the My Experiences page.";
  }
  return "Please return to the Results Page";
});

const buttonText = computed<string>(() => {
  if (hasOrder.value) {
    return "Return to My Experiences";
  }
  return "Return to Results Page";
});

const buttonRouteName = computed<string>(() => {
  if (hasOrder.value) {
    return "experiences";
  }
  return "results";
});
</script>

<template>
  <div class="absolute inset-0 flex items-center justify-center bg-white z-10">
    <div
      class="flex flex-col items-center justify-center font-montserrat text-[#1e2648]"
    >
      <ErrorPlane class="mt-16" />
      <h1 class="font-bold text-4xl mt-16">Uh-oh!</h1>
      <p class="mt-4" id="registration-errors-text">
        It looks like you don't have access to this page. {{ returnText }}
      </p>
      <RouterLink :to="{ name: buttonRouteName }">
        <div class="bg-cyan-200 px-4 py-3 flex flex-row justify-between mt-16">
          <ArrowBack class="mr-4 mt-1" />
          <span id="error-button-text" class="text-white uppercase font-semibold"
            >{{ buttonText }}</span
          >
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<style scoped>
</style>
